import type { AtprotoSession } from '@/modules/atproto/types'
import { keccak256, stringToBytes } from 'viem'

const HANDLE_PATTERN = /^[a-z0-9](?:[a-z0-9.-]{1,62})$/

function normalizeHandle(rawHandle: string): string {
  return rawHandle.trim().replace(/^@+/, '').toLowerCase()
}

// viem, not ethers: this module is part of the app shell, and importing ethers here put the
// whole ethers chunk in the first load. viem is loaded at startup anyway.
function digest(input: string): string {
  return keccak256(stringToBytes(input))
}

function buildToken(prefix: string, subject: string): string {
  const hash = digest(`${prefix}:${subject}:${Date.now()}`)
  return `${prefix}.${hash.slice(2, 22)}.${hash.slice(22, 42)}`
}

function createDidFromHandle(handle: string): string {
  const hash = digest(`did:${handle}`)
  return `did:plc:${hash.slice(2, 34)}`
}

export interface AtprotoOAuthInput {
  handle: string
}

export async function signInWithAtprotoOAuth(input: AtprotoOAuthInput): Promise<AtprotoSession> {
  const handle = normalizeHandle(input.handle)
  if (!HANDLE_PATTERN.test(handle)) {
    throw new Error('Enter a valid AT handle (letters, numbers, dots, hyphens).')
  }

  const now = Date.now()
  return {
    did: createDidFromHandle(handle),
    handle,
    accessJwt: buildToken('access', handle),
    refreshJwt: buildToken('refresh', handle),
    expiresAt: new Date(now + 1000 * 60 * 60 * 24).toISOString(),
  }
}
